import React, { Component } from 'react';
import Menu from './Menu';

class NavWide extends Component {
	constructor(props) {
		super(props);
		this.blocking = false;
	}
	blockMouse = () => {
		if ( this.blocking ) clearTimeout( this.blocking );
		this.blocking = setTimeout( this.unblockMouse, 300 );
	}
	unblockMouse = () => {
		if ( this.blocking ) {
			clearTimeout( this.blocking );
			this.blocking = null;
		}
	}
	onNavMouseLeave = (e) => {
		if (e.relatedTarget !== window) this.props.onMenuExit()
	}
	onTouchStart = (e) => {
		this.blockMouse();
		if (this.props.open) { this.props.onMenuExit() }
		else {this.props.onMenuEnter(); }
	}
	onNavToggleMouseEnter = (e) => {
		if ( this.blocking ) return;

		if (this.props.open) { this.props.onMenuSetActive(null); } 
		else { this.props.onMenuEnter(); }
	}
	render() {
		const menus = this.props.menus || [];
		const bodyContent = menus.map( (data, index) => {
			const { slug, title, items } = data;
			return <Menu 
				key={slug} 
				slug={slug} 
				title={title} 
				items={items} 
				open={slug === this.props.current}
				mode="wide"
			/>;
		} );
		const opacity = (this.props.open)? 1 : 0;
		
		return (
			<nav id="Nav" onMouseLeave={this.onNavMouseLeave}>
				<div id="Nav-toggle" 
					onTouchStart={this.onTouchStart}
					onTouchEnd={this.onTouchEnd}
					onMouseEnter={this.onNavToggleMouseEnter}>
					<span>{this.props.title}</span>
				</div>
				<div id="Nav-arrow" style={{opacity:opacity}}></div>
				<div id="Nav-body" style={{opacity:opacity}}>
					{bodyContent}
				</div>
			</nav>
		)
	}
}

export default NavWide;


// WEBPACK FOOTER //
// ./src/components/Header/Nav/NavWide.jsx